import { TranslationKey } from '@/modules/i18n/types'
import { UserService } from '@duck/api-definitions'

const roleColors: Record<UserService.UserRole, string> = {
  'admin': 'bg-emerald-300/15 text-emerald-300 border border-emerald-300',
  'partner': 'bg-indigo-500/10 text-indigo-400 border border-indigo-600/80',
  'user': 'bg-muted/10 border border-primary/40',
}
export const getRoleBadgeColor = (role: UserService.UserRole): string => {
  return roleColors[role]
}

export const formatRole = (role: string): string => {
  return role.charAt(0).toUpperCase() + role.slice(1)
}

export const getStatusBadgeColor = (isActive: boolean, isVerified: boolean): string => {
  if (isActive && isVerified) {
    return 'bg-success/10 text-success border border-success/20'
  } else if (isActive && !isVerified) {
    return 'bg-warning/10 text-warning border border-warning/20'
  } else {
    return 'bg-error/10 text-error border border-error/20'
  }
}

export const formatStatus = (isActive: boolean, isVerified: boolean): TranslationKey => {
  if (isActive && isVerified) {
    return 'users.activeVerified'
  } else if (isActive && !isVerified) {
    return 'users.activeUnverified'
  } else {
    return 'users.inactive'
  }
}

export const formatAccessGroups = (accessGroups: string[]): string => {
  return accessGroups.join(', ')
}

export type UserColumnFilterType = 'text' | 'enum' | 'async-search'

export interface Column {
  key: keyof import('@duck/api-definitions').UserService.User
  label: TranslationKey
  sortable: boolean
  visible: boolean
  /** When set, a filter control is shown in the column header. */
  filterType?: UserColumnFilterType
  filterKey?: string
}

/** Role filter options for the enum dropdown. */
export const roleFilterOptions: { value: UserService.UserRole; label: TranslationKey }[] = [
  { value: 'admin', label: 'common.admin' },
  { value: 'partner', label: 'common.partner' },
  { value: 'user', label: 'common.user' },
]

/** Active status filter options (boolean → enum dropdown). */
export const activeFilterOptions: { value: string; label: TranslationKey }[] = [
  { value: 'true', label: 'common.active' },
  { value: 'false', label: 'common.inactive' },
]

/** Verified status filter options (boolean → enum dropdown). */
export const verifiedFilterOptions: { value: string; label: TranslationKey }[] = [
  { value: 'true', label: 'common.verified' },
  { value: 'false', label: 'common.unverified' },
]

export const baseColumns: Column[] = [
  { key: 'id', label: 'common.id', sortable: true, visible: false },
  { key: 'email', label: 'common.user', sortable: true, visible: true, filterType: 'text', filterKey: 'search' },
  { key: 'role', label: 'common.role', sortable: true, visible: true, filterType: 'enum', filterKey: 'role' },
  { key: 'accessGroups', label: 'common.accessGroups', sortable: false, visible: true, filterType: 'enum', filterKey: 'accessGroups' },
  { key: 'organizationId', label: 'common.organization', sortable: true, visible: false, filterType: 'async-search', filterKey: 'organizationId' },
  { key: 'invitationId', label: 'common.invitationId', sortable: true, visible: false },
  { key: 'createdAt', label: 'common.createdAt', sortable: true, visible: true },
  { key: 'lastLoginAt', label: 'common.lastLoginAt', sortable: true, visible: true },
  { key: 'notes', label: 'common.notes', sortable: false, visible: false },
]
